<div id="{{'appCard-' + appLink.resourceId}}" class="appCard" (click)="onClick()">
    <a id="ff_icon_{{appLink.resourceId}}">
        <div class="new" [style.opacity]="appLink.showAsNew?'1':'0'">{{appLink.newTextOverride || 'New'}}</div>
        <img class="figure" [src]="appLink.iconUrl">
        <h3 class="name">
            {{appLink.name}}
        </h3>
    </a>
</div>